import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class PollSubmitButton extends Component {
  view() {
    const state = this.attrs.state;
    return m(Button, {
      className: "Button Button--primary Poll-submit",
      loading: state.loadingOptions,
      onclick: event => this.pollButtonSubmit(state, event),
      disabled: !state.hasSelectedOptions()
    }, app.translator.trans('fof-polls.forum.poll.submit_button'));
  }

  /**
   * Event handler for submit button being clicked
   */

  pollButtonSubmit(state, event) {
    state.onsubmit();
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollSubmitButton', PollSubmitButton);